/**
 * PaymentCancel — landing page when the user cancels Stripe Checkout.
 * We don't change any state server-side; this is a plain informational page
 * with a button back to the dashboard.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div
      data-testid="payment-cancel-page"
      className="min-h-screen bg-[#1A1A1A] text-[#F2F2F2] flex items-center justify-center p-6"
    >
      <div className="max-w-md w-full bg-[#2B2B2B] rounded-xl p-8 border border-white/10 text-center">
        <XCircle className="w-14 h-14 text-[#F59E0B] mx-auto" />
        <h1 className="text-2xl font-semibold mt-5">Checkout cancelled</h1>
        <p className="text-sm text-[#A1A1AA] mt-2">
          No charge was made. Your current plan continues as before.
        </p>
        <Button
          onClick={() => navigate('/')}
          className="mt-6 bg-[#1ABC9C] text-black hover:bg-[#1ABC9C]/90"
          data-testid="payment-cancel-continue-btn"
        >
          Back to dashboard
        </Button>
      </div>
    </div>
  );
}
